import React, { useEffect } from 'react';

type ToastProps = {
  message: string;
  duration?: number; // 초 단위
  onClose: () => void;
};

const Toast: React.FC<ToastProps> = ({ message, duration = 3, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration * 1000); // ms로 변환

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed left-1/2 top-5 z-50 -translate-x-1/2">
      <div className="animate-fade-in-out min-w-[300px] max-w-xl rounded-lg bg-green-600 px-6 py-4 text-center text-lg font-medium text-white shadow-lg">
        {message}
      </div>
    </div>
  );
};

export default Toast;
